import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CategoryWrapper = styled(Box)<{ titlelength?: number; ishovered?: string }>`
  padding: ${theme.spacing.small}px ${theme.spacing.md}px ${theme.spacing.md}px ${theme.spacing.small}px;
  border-radius: ${theme.attributes.borderRadius.normal};
  background: ${theme.colors.backgroundMedium};
  box-shadow: ${theme.attributes.boxShadow.overallScoreWrapper};
  height: 234px;
  width: calc(100% - 12px);

  html[data-theme='light'] & {
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.08);
  }

  ${({ ishovered }) =>
    ishovered &&
    ishovered === 'true' &&
    `
      background: ${theme.colors.legacyPrimaryLight3};
  `};

  .card-wrapper-loading {
    display: flex;
    width: 100%;
    gap: ${theme.spacing.xSmall}px;

    .card-loading {
      border-radius: ${theme.attributes.borderRadius.normal};
      background: ${theme.colors.backgroundLight};
      flex-basis: 33.33%;
      width: 100%;
      height: 84px;
    }
  }

  .header-loading {
    display: flex;
    align-items: center;
    margin-bottom: ${theme.spacing.small}px;

    .category-title-loading {
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.bold};
      font-size: ${theme.typography.fontSize.large};
      line-height: 20px;
      letter-spacing: 0.1px;
      color: ${theme.colors.foreground};
      margin-left: ${theme.spacing.small}px;
    }
  }

  .header {
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.spacing.xSmall}px;
    flex-direction: column;

    ${({ titlelength }) =>
      titlelength &&
      titlelength > 24 &&
      `
        margin-bottom: ${theme.spacing.xSmall}px;
      `};

    .category-title {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.25px;

      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;

      &:hover {
        color: ${theme.colors.cta};
        text-decoration-line: underline;
        cursor: pointer;
      }
    }

    .category-margin {
      margin-bottom: 26px;
    }

    .over-perform {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.half}px;
      margin-top: ${theme.spacing.xsm}px;

      b {
        color: ${theme.colors.foreground};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 20px;
        letter-spacing: 0.1px;
      }

      .value {
        color: ${theme.colors.foreground};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.medium};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 16px;
        letter-spacing: 0.5px;
      }
    }

    .action {
      display: inline-flex;
      align-items: center;
      gap: ${theme.spacing.xSmall}px;
      cursor: pointer;

      .category-all {
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.mediumSmall};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 16px;
        letter-spacing: 0.5px;
        color: ${theme.colors.cta};
      }
    }
  }

  .data-sources-wrapper {
    display: flex;
    align-items: center;
    margin-top: ${theme.spacing.md}px;
    gap: 5px;

    ${({ titlelength }) =>
      titlelength &&
      titlelength > 24 &&
      `
          margin-top: ${theme.spacing.xsm}px;
      `};

    .data-sources-text {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.medium};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 16px;
      letter-spacing: 0.4px;
      flex-shrink: 0;
    }

    .data-sources-icons-wrapper {
      display: flex;
      align-items: center;
      gap: 5px;

      img {
        border-radius: ${theme.attributes.borderRadius.circle};
      }

      .error-wrapper {
        border-radius: ${theme.attributes.borderRadius.circle};
        position: relative;
        cursor: pointer;
        border: 1px solid ${theme.baseColors.info[50]};
        box-sizing: content-box;

        svg {
          position: absolute;
          bottom: -2px;
          left: 5px;

          &.error-content {
            left: 7px;
            bottom: 0;
          }
        }
      }

      .data-sources-count-text {
        color: ${theme.colors.calendarDay};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.mediumSmall};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 16px;
        letter-spacing: 0.5px;
        white-space: nowrap;

        html[data-theme='light'] & {
          color: ${theme.colors.foreground};
        }
      }
    }
  }

  .available-status-sources-text {
    color: ${theme.colors.calendarDay};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.medium};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 16px;
    letter-spacing: 0.4px;
    margin-top: ${theme.spacing.small}px;
    opacity: 0.38;

    html[data-theme='light'] & {
      color: ${theme.colors.menuItemText};
      opacity: 1;
    }

    ${({ titlelength }) =>
      titlelength &&
      titlelength > 24 &&
      `
          margin-top: ${theme.spacing.xsm}px;
      `};
  }

  html[data-theme='light'] & {
    border-radius: 12px;
    border: 1px solid #ebebeb;
    background: ${theme.colors.backgroundDarker};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  }

  ${({ ishovered }) =>
    ishovered &&
    ishovered === 'true' &&
    `
      html[data-theme='light'] & {
        background: ${theme.colors.hoverPrimary};
      }
    `};
`

export const ExploreCategoryWrapper = styled(Box)`
  display: flex;
  width: calc(100% - 12px);

  .scale {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .scale-text {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.mediumSmall};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 16px;
      letter-spacing: 0.5px;
      opacity: 0.38;

      html[data-theme='light'] & {
        color: ${theme.colors.menuItemText};
        opacity: 1;
      }
    }
  }

  .chart-button-wrapper {
    background-color: ${theme.colors.legacyAlpha4};
    height: 116px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${theme.colors.legacyBorderLow2};
    border-radius: ${theme.attributes.borderRadius.secondary};

    .MuiButtonBase-root {
      color: ${theme.colors.cta};

      html[data-theme='light'] & {
        color: ${theme.colors.foreground};
      }
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
      letter-spacing: 0.1px;
      text-transform: none;
      opacity: 1 !important;

      svg {
        margin-right: ${theme.spacing.xSmall}px;
      }

      /* The arrow bakes fill="#DEBDD9"; a CSS fill property beats the presentation attribute. */
      html[data-theme='light'] & {
        svg path {
          fill: ${theme.colors.cta};
        }
      }
    }

    @media (min-width: 1920px) {
      height: 124px;
    }
  }
`

export const EmptyDataCategoryWrapper = styled(Box)`
  display: flex;
  width: calc(100% - 12px);

  .scale {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .scale-text {
      color: ${theme.colors.foreground};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.mediumSmall};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 16px;
      letter-spacing: 0.5px;
    }
  }

  .chart-button-wrapper {
    background-color: ${theme.colors.legacyPrimaryDark};
    height: 116px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid ${theme.colors.legacyBorderLow2};
    border-radius: ${theme.attributes.borderRadius.secondary};

    .initializing-text {
      color: #ffe082;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.normal};
      line-height: 20px;
      letter-spacing: 0.25px;
    }

    .no-data-text {
      color: ${theme.colors.controlBorder};
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.medium};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 16px;
      letter-spacing: 0.5px;
    }

    html[data-theme='light'] & {
      .initializing-text {
        color: ${theme.colors.menuItemText};
      }

      .no-data-text {
        color: ${theme.colors.devicesSecondaryText};
      }
    }

    .MuiButtonBase-root {
      color: ${theme.colors.cta};

      html[data-theme='light'] & {
        color: ${theme.colors.foreground};
      }
      text-align: center;
      font-family: ${theme.typography.fontFamily.primary};
      font-size: ${theme.typography.fontSize.large};
      font-style: normal;
      font-weight: ${theme.typography.fontWeight.bold};
      line-height: 20px;
      letter-spacing: 0.1px;
      text-transform: none;

      svg {
        margin-right: ${theme.spacing.xSmall}px;
      }
    }

    @media (min-width: 1920px) {
      height: 124px;
    }
  }
`
